import { create } from 'zustand';

type CustomFilterStoreState = {
  selectedDateRange: Date[] | null;
  setSelectedDateRange: (range: Date[] | null) => void;
  applyFilters: () => void;
  isFilterApplied: boolean;
  setIsFilterApplied: (isFilterApplied: boolean) => void;
};

export const useCustomFilterStore = create<CustomFilterStoreState>()((set) => ({
  selectedDateRange: null,
  setSelectedDateRange: (range) => set({ selectedDateRange: range }),
  applyFilters: () => set({ isFilterApplied: true }),
  isFilterApplied: false,
  setIsFilterApplied: (isFilterApplied) => set({ isFilterApplied }),
}));
